
import Button from "../Button";
import {useContext} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import { BsHourglassTop } from "react-icons/bs";
const ReportedCard=({reportedMessage})=>{
    const serviceContext=useContext(AuthenticationServiceContext);
    const handleRedirect=()=>{
        const price=serviceContext?.process?.payment?.info ? serviceContext.process.payment.info.init_amount :null
        return serviceContext.handleRedirectToDivar({price,status:"fail"})
    }
    return  <div className="flex flex-col items-center justify-center ">
        <div className="flex justify-center mt-10">
            <h1 className="text-3xl text-gray-600  ">
                ونیفای
            </h1>
        </div>
        <div className="p-3 mt-5  mx-2 flex w-11/12 md:w-6/12 lg:w-4/12 bg-white rounded-xl  flex-col items-center justify-center">
            <BsHourglassTop className="text-5xl mb-7 text-yellow-500"/>
            <h1 className="font-bold mb-2 text-center">در حال بررسی</h1>
            <p className=" text-sm  text-center  ">{reportedMessage}</p>
            <div className="border-t w-full mt-3  pt-3">
                <Button theme="warning" className="text-sm  w-full   " rounded="rounded-xl" onClick={handleRedirect}>بازگشت به دیوار </Button>
            </div>
        </div>
    </div>
}
export default ReportedCard;